import React from 'react';
import { Chart } from 'primereact/chart';

// O wrapper Chart do PrimeReact recria a instância do Chart.js a cada render
// (useEffect sem array de dependências) — sem memo, qualquer re-render do
// componente pai (ex.: uma lista de opções de dropdown terminando de
// carregar) recria o gráfico do zero e reanima a entrada das barras.
// React.memo evita isso: só re-renderiza quando data/options mudam de fato.
export const MemoChart = React.memo(function MemoChart({ type = 'bar', data, options, style }) {
    return <Chart type={type} data={data} options={options} style={style} />;
});
